import React from 'react';
import { Row, Col, Button, Divider, Modal, Grid } from 'antd';
import styled from 'styled-components';
import Link from 'next/link';
import NImage from 'next/image';
import Image from 'components/Image';
import { SectionTitle } from 'components/Section';
import Avatar from 'components/Avatar';
import SocialLinks from 'components/SocialLinks';
import RodoText from 'components/RodoText';
import ContactForm from './ContactForm';
import EventDate from 'components/EventDate';
import Section from 'components/Section';
import { SkyscraperMobile } from 'components/Ads';
import DefaultBG from 'public/static/images/wydarzenia-konferencje.png';
import PatronatImage from 'public/static/images/patronat.svg';

const { useBreakpoint } = Grid;

const BranchAddress = styled.p`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: right;
    margin: 0;
    color: ${({ theme }) => theme.colors.primary};
`;

const StyledSection = styled(Section)`
    @media (max-width: 992px) {
        margin-bottom: 35px;
    }
`;

const BranchEmail = styled.p`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: right;
    margin: 0;
    color: ${({ theme }) => theme.colors.primary};
`;

const BranchPhone = styled.p`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    margin: 0;
    text-align: right;
    color: ${({ theme }) => theme.colors.greyishBrownTwo};
`;

const PersonContainer = styled.div`
    text-align: right;
    word-wrap: break-word;
    color: ${({ theme }) => theme.colors.greyishBrownTwo};
    @media (max-width: 992px) {
        text-align: center;
    }
`;

const PersonRow = styled.p`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    margin: 0;
    color: ${({ theme }) => theme.colors.greyishBrownTwo};
    a {
        color: ${({ theme }) => theme.colors.primary};
    }
`;
const BranchName = styled.h6`
    font-size: 18px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: right;
    margin: 0;
    padding-bottom: 1em;
    a {
        color: ${({ theme }) => theme.colors.greyishBrown};
    }
`;

const LogoContainer = styled.div`
    position: absolute;
    height: 270px;
    width: 270px;
    top: 50%;
    left: 3%;
    border: 1px solid #b7cbd9;
    @media (max-width: 992px) {
        height: 200px;
        width: 200px;
        top: 55%;
        left: 50%;
        transform: translateX(-50%);
    }
    @media (max-width: 576px) {
        top: 15%;
    }
`;

const EventName = styled.h1`
    font-size: 32px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    @media (max-width: 992px) {
        text-align: center;
    }
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const EventType = styled.h2`
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    margin: 0;
    text-transform: capitalize;
    @media (max-width: 992px) {
        text-align: center;
    }
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const EventDateText = styled.p`
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    margin: 0;
    @media (max-width: 992px) {
        text-align: center;
    }
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const EventText = styled.span`
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    margin: 0;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const Address = styled.h2`
    font-size: 20px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    @media (max-width: 992px) {
        text-align: center;
    }
    margin: 0;
    color: ${({ theme }) => theme.colors.primary};
`;

const URL = styled.a`
    font-size: 20px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const TextBold = styled.p`
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const Text = styled.p`
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const RodoTextSpan = styled.span`
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.greyishBrown};
`;

const OrganizingCompanySection = styled(Section)`
    @media (max-width: 992px) {
        align-items: center;
        margin-top: 75px;
    }
`;

const CenteredMobileText = styled.div`
    @media (max-width: 992px) {
        text-align: center;
    }
`;

export interface Props {
    event: Occurrence;
    events: Occurrence[];
    organizedEvents: Occurrence[];
    ads: PageAds;
}

const EventContact = ({ event, ads }: Props): React.JSX.Element => {
    const {
        name,
        type,
        logo,
        location,
        seoSlug,
        startDate,
        endDate,
        socialLinks,
        premium,
        premiumBackground,
        website,
        organizer,
        organizingCompany,
        addresses = [],
        contactPersons = []
    } = event;
    const screens = useBreakpoint();
    const showModal = () => {
        Modal.info({
            okText: 'Zamknij',
            width: screens.md ? '80%' : '100%',
            title: 'Informacja o przetwarzaniu danych osobowych',
            content: (
                <div style={{ marginLeft: '-35px' }}>
                    <RodoText />
                </div>
            )
        });
    };
    const { skyscraper } = ads;
    return (
        <>
            <Row style={{ position: 'relative' }}>
                <Col span={24}>
                    {premium && premiumBackground && (
                        <Image
                            type="billboard"
                            width={1200}
                            height={303}
                            src={premiumBackground}
                            alt={name}
                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    )}

                    {(!premium || !premiumBackground) && (
                        <NImage
                            width={1200}
                            height={303}
                            src={DefaultBG}
                            alt={name}
                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    )}

                    <LogoContainer>
                        <Image
                            type="logo"
                            width={270}
                            height={270}
                            src={logo}
                            alt={name}
                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </LogoContainer>
                </Col>
            </Row>
            <Section gutter={16}>
                <Col
                    xs={{ span: 24, order: 2 }}
                    lg={{ offset: 8, span: 11, order: 1 }}
                    xxl={{ offset: 7, span: 11, order: 1 }}
                >
                    <Row>
                        <Col span={24}>
                            <CenteredMobileText>
                                <EventName>{name}</EventName>
                                <EventType>{type}</EventType>
                                <EventDateText>
                                    <EventDate startDate={startDate} endDate={endDate} />
                                </EventDateText>
                                <Address>{location}</Address>
                                {website && (
                                    <URL target="_blank" href={website} rel="noopener noreferrer">
                                        {website}
                                    </URL>
                                )}
                            </CenteredMobileText>
                        </Col>
                        <Col span={24} style={{ marginTop: 25 }}>
                            <EventText>
                                Organizator: <strong>{organizer}</strong>
                            </EventText>
                        </Col>
                        <Col span={24}>
                            <Divider
                                style={{
                                    margin: '5px 0 24px 0',
                                    width: '80%',
                                    minWidth: '80%'
                                }}
                            />
                            <Link href={`/wydarzenia/${seoSlug}`}>
                                <Button style={{ padding: '0 30px' }}>Wróć do szczegółów</Button>
                            </Link>
                        </Col>
                    </Row>
                </Col>
                <Col
                    xs={{ span: 24, order: 1 }}
                    lg={{ span: 5, order: 2 }}
                    xxl={{ span: 6, order: 2 }}
                >
                    <OrganizingCompanySection gutter={[16, 16]} justify="space-between">
                        <Col
                            xs={{ span: 8, order: 1 }}
                            md={{ span: 4, order: 1 }}
                            lg={{ span: 24, order: 1 }}
                        >
                            {organizingCompany && (
                                <div>
                                    <Link href={`/katalog-firm/${organizingCompany.seoSlug}`}>
                                        <Image
                                            type="logo"
                                            alt={organizingCompany.name}
                                            height={272}
                                            width={272}
                                            src={organizingCompany.logo}
                                            style={{
                                                maxWidth: '100%',
                                                height: 'auto',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </Link>
                                </div>
                            )}
                        </Col>
                        <Col
                            xs={{ span: 16, order: 2 }}
                            md={{ span: 20, order: 2 }}
                            lg={{ span: 24, order: 2 }}
                        >
                            <Row justify="end">
                                {event.patronate && (
                                    <Col>
                                        <NImage
                                            src={PatronatImage}
                                            width={120}
                                            height={22}
                                            alt="patronat"
                                            style={{ maxWidth: '100%', objectFit: 'contain' }}
                                        />
                                    </Col>
                                )}
                                <Col>
                                    <SocialLinks {...socialLinks} />
                                </Col>
                            </Row>
                        </Col>
                    </OrganizingCompanySection>
                </Col>
            </Section>
            <Divider />
            <Row justify="center">
                <Col xs={24} sm={12}>
                    <SkyscraperMobile id={skyscraper[0]} margin="12px auto 12px auto" />
                </Col>
                <Col xs={24} sm={12}>
                    <SkyscraperMobile id={skyscraper[1]} margin="12px auto 12px auto" />
                </Col>
            </Row>
            <StyledSection gutter={16}>
                <Col xs={24} md={7}>
                    <SectionTitle
                        title={
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: 'Kontakt z&nbsp;organizatorem'
                                }}
                            />
                        }
                    />
                </Col>
                <Col span={24} md={11}>
                    <Row>
                        <Col span={24}>
                            <TextBold>Chcesz skontaktować się z organizatorem? </TextBold>
                            <Text>
                                Wypełnij formularz. Twoje zapytanie zostanie wysłane jako e-mail do
                                osoby kontaktowej.
                            </Text>
                        </Col>
                    </Row>
                    <Section>
                        <Col span={24}>
                            <ContactForm seoSlug={seoSlug} />
                        </Col>
                    </Section>
                    <Row>
                        <Col span={24}>
                            <RodoTextSpan>
                                RAVEN MEDIA sp. z o.o. informuje, że będzie administratorem
                                dotyczących Pani/Pana danych osobowych podanych w niniejszym
                                formularzu i w toku realizacji zamówionych w formularzu usług.
                                <Button onClick={showModal} type="link">
                                    Więcej...
                                </Button>
                            </RodoTextSpan>
                        </Col>
                    </Row>
                </Col>
            </StyledSection>
            <StyledSection>
                {addresses.length > 0 && (
                    <Col span={24}>
                        <Divider />
                        <Section>
                            <Col span={7}>
                                <SectionTitle title="Dane adresowe" />
                            </Col>
                            <Col span={17}>
                                <Row gutter={[16, 16]}>
                                    {addresses.map((address) => (
                                        <Col sm={12} md={8} key={address.name}>
                                            {address.name && (
                                                <BranchName>{address.name}</BranchName>
                                            )}
                                            <BranchAddress>
                                                {address.street}
                                                <br />
                                                {`${address.zip ? address.zip : ''} ${
                                                    address.city
                                                }, ${address.country}`}
                                            </BranchAddress>
                                            {address.phoneNumber && (
                                                <BranchPhone>{`tel: ${address.phoneNumber}`}</BranchPhone>
                                            )}
                                            {address.phoneNumber2 && (
                                                <BranchPhone>{`tel: ${address.phoneNumber2}`}</BranchPhone>
                                            )}
                                            {address.fax && (
                                                <BranchPhone>{`faks: ${address.fax}`}</BranchPhone>
                                            )}
                                            {address.email && (
                                                <BranchEmail>
                                                    <a
                                                        href={`mailto:${address.email}`}
                                                        target="_blank"
                                                        dangerouslySetInnerHTML={{
                                                            __html: address.email.replace(
                                                                '@',
                                                                '&#8203;@'
                                                            )
                                                        }}
                                                        rel="noreferrer"
                                                    />
                                                </BranchEmail>
                                            )}
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Section>
                    </Col>
                )}
                {contactPersons.length > 0 && (
                    <Col span={24}>
                        <Divider />
                        <Section justify="center">
                            <Col span={24}>
                                <SectionTitle title="Osoby kontaktowe" />
                            </Col>
                            {contactPersons.map((person) => {
                                return (
                                    <Col md={12} xl={8} key={person.name}>
                                        <PersonContainer>
                                            <Avatar person={person} size={90} />
                                            <PersonRow
                                                style={{ fontWeight: 400 }}
                                            >{`${person.firstName} ${person.lastName}`}</PersonRow>
                                            <PersonRow>{person.jobTitle}</PersonRow>
                                            <PersonRow>{person.department}</PersonRow>
                                            <PersonRow>tel: {person.phone}</PersonRow>
                                            {person.email && (
                                                <PersonRow>
                                                    <a
                                                        href={`mailto:${person.email}`}
                                                        target="_blank"
                                                        dangerouslySetInnerHTML={{
                                                            __html: person.email.replace(
                                                                '@',
                                                                '&#8203;@'
                                                            )
                                                        }}
                                                        rel="noreferrer"
                                                    />
                                                </PersonRow>
                                            )}
                                        </PersonContainer>
                                    </Col>
                                );
                            })}
                        </Section>
                    </Col>
                )}
            </StyledSection>
        </>
    );
};

export default EventContact;
